import {
	ROUTE_MODERATION_FINANCIAL_ENTRY_SPLIT,
	ROUTE_MODERATION_FINANCIAL_ENTRY_SPLIT_LIST,
	ROUTE_MODERATION_FINANCIAL_ENTRY_SPLIT_DETAIL

} from 'constants/RouterNames'

const moderationFinancialEntrySplit = () => import('components/pages/secured/financial/moderationFinancialEntrySplit/moderationFinancialEntrySplit')
const moderationFinancialEntrySplitList = () => import('components/pages/secured/financial/moderationFinancialEntrySplit/moderationFinancialEntrySplitList/moderationFinancialEntrySplitList')
const moderationFinancialEntrySplitDetail = () => import('components/pages/secured/financial/moderationFinancialEntrySplit/moderationFinancialEntrySplitDetail/moderationFinancialEntrySplitDetail')

const moderationFinancialEntrySplitRoute = {
	path: '/moderacao-lancamentos-financeiros-split',
	redirect: '/listagem-moderacao-lancamentos-financeiros-split',
	component: moderationFinancialEntrySplit,
	name: ROUTE_MODERATION_FINANCIAL_ENTRY_SPLIT.name,
	meta: { breadcrumb: { name: 'Moderação lançamentos manuais' }, requiresAuthorities: ROUTE_MODERATION_FINANCIAL_ENTRY_SPLIT.routerAuth },
	children: [
		{ path: '/listagem-moderacao-lancamentos-financeiros-split', component: moderationFinancialEntrySplitList, name: ROUTE_MODERATION_FINANCIAL_ENTRY_SPLIT_LIST.name, meta: { requiresAuthorities: ROUTE_MODERATION_FINANCIAL_ENTRY_SPLIT_LIST.routerAuth } },
		{ path: '/edicao-moderacao-lancamentos-financeiros-split/:financialEntryId', props: true, component: moderationFinancialEntrySplitDetail, name: ROUTE_MODERATION_FINANCIAL_ENTRY_SPLIT_DETAIL.name, meta: { requiresAuthorities: ROUTE_MODERATION_FINANCIAL_ENTRY_SPLIT_DETAIL.routerAuth } }
	]
}

export default moderationFinancialEntrySplitRoute
